import styles from './WsiCard.module.css';
import api from '../API';
import { girderThumbnailUrl } from '../utils/girderThumbnailUrl';
import { Link } from 'react-router-dom';

function WsiCard(item){
    // console.log('making wsi card', item._id)
    return (
        <div key={item._id} className={styles.wsiCard}>
            <Link to={`/item/${item._id}`}>
                <div>
                    <img src={girderThumbnailUrl(api, item._id)} alt="" />
                </div>
                {item.name && <div className={styles.title}>{item.name}</div>}
            </Link>
        </div>
    )
}

export default WsiCard;